export const environment = {
	production: true,

	apiURL: "https://dea.mifmaroc.com/backend/api",
	backendURL: "https://dea.mifmaroc.com/backend",
	//apiURL: "http://10.10.128.41:1372/api",
	//backendURL: "http://10.10.128.41:1372",

	pageSizeAll: 99999999,

	defaultauth: "fackbackend",
	firebaseConfig: {
		apiKey: "",
		authDomain: "",
		databaseURL: "",
		projectId: "",
		storageBucket: "",
		messagingSenderId: "",
		appId: "",
		measurementId: "",
	},
};
